export const MQ = {
    mobile: 0,
    tabletPortrait: 768,
    tabletLandscape: 1024,
    desktop: 1280,
    desktopXl: 1440,
    desktopXxl: 1920
};
